import { all, call, select, spawn, take } from 'redux-saga/effects';
import { LOG_IN, LOG_OUT, SET_ANONYMOUS } from './actions';
import { getUserState } from './selectors';
import { persistUserState } from './storage';

/* eslint-disable no-constant-condition */
export function* watchChangeUserState() {
  while (yield take([LOG_IN, LOG_OUT, SET_ANONYMOUS])) {
    const state = yield select(getUserState);
    yield call(persistUserState, state.toJS());
  }
}

export default function* root() {
  yield all([
    spawn(watchChangeUserState)
  ]);
}
/* eslint-enable no-constant-condition */
